module.exports = __webpack_public_path__ + "static/media/play.4f3c873c.PNG";